/**
 * Creates a signal with a unique name for event-based communication.
 *
 * IMPORTANT: Each signal must have a unique name to prevent conflicts.
 * If you reuse a name, multiple signals will listen to the same event
 * and could interfere with each other's behavior.
 */
function signal(uniqueName: string): {
  emit: () => void;
  wait: () => Promise<void>;
} {
  const eventTarget = new EventTarget();

  const emit = (): void => {
    eventTarget.dispatchEvent(new Event(uniqueName));
  };

  const wait = (): Promise<void> => {
    return new Promise<void>((resolve) => {
      eventTarget.addEventListener(uniqueName, () => resolve(), {once: true});
    });
  };

  return {emit, wait};
}

export default signal;
